export function buildLinkedInShareUrl({ verificationUrl, badgeName, issuerName, issueDate }) {
    const params = new URLSearchParams({
        startTask: 'CERTIFICATION_NAME',
        name: badgeName,
        organizationName: issuerName || 'SDS Industry Consortium',
        issueYear: new Date(issueDate).getFullYear().toString(),
        issueMonth: (new Date(issueDate).getMonth() + 1).toString(),
        certUrl: verificationUrl,
        certId: verificationUrl.split('/').pop(),
    });
    return `https://www.linkedin.com/profile/add?${params.toString()}`;
}
